/* Privatefun — de filterknop op telefoon naar de kruimelpadregel verhuizen.

   WAAROM VERHUIZEN EN NIET OMHOOG SCHUIVEN. De knop staat in .facets-toggle, en dat blok
   zit in .collection-wrapper, één niveau dieper dan het kruimelpad. Ze zijn dus geen buren
   en met CSS alleen krijg je ze niet op dezelfde regel zonder een negatieve marge ter grootte
   van de kruimelpadregel. Die marge klopt alleen zolang dat kruimelpad precies één regel is —
   bij een diepe categorie op een smal scherm loopt het pad over twee regels en schuift de
   knop over de tekst heen. Een vast getal dat van de inhoud afhangt is geen oplossing.

   Daarom zetten we het knopvak gewoon ín het kruimelpad. Dan is het een flex-item naast de
   kruimels, mag het pad groeien zoveel het wil, en valt de knop bij plaatsgebrek vanzelf naar
   de volgende regel in plaats van ergens overheen.

   WAAROM DIT MAG. De knop opent de lade met on:click="#filters-drawer/open". Dat is een
   verwijzing op id, geen verwijzing via de DOM-structuur, dus hij blijft werken waar hij ook
   staat. Het vak blijft bovendien binnen dezelfde <results-list>, dus ook alles wat dáárop
   leunt blijft kloppen.

   Boven de 990px gebeurt er niets: daar staat het filter als kolom naast de producten en
   heeft deze knop geen functie. Draai je het scherm of maak je het venster breder, dan gaat
   het vak terug naar waar het vandaan kwam.

   Er luistert ook een waarnemer mee op de resultatenlijst. Het thema tekent die lijst opnieuw
   bij elke filterwijziging, en dan is het knopvak een nieuw element dat opnieuw verhuisd moet
   worden.
*/
(function () {
  var GRENS = '(max-width: 989px)';
  var mq = window.matchMedia(GRENS);
  var thuis = null;
  var bezig = false;

  function plaats() {
    var wrapper = document.querySelector('.facets-toggle__wrapper');
    if (!wrapper) return;

    var nav = document.querySelector('nav.collection-breadcrumbs');
    var toggle = document.querySelector('.facets-toggle');

    if (!thuis && wrapper.parentElement !== nav) thuis = wrapper.parentElement;

    if (mq.matches && nav) {
      if (wrapper.parentElement !== nav) {
        nav.appendChild(wrapper);
      }
      nav.classList.add('pf-kruimelrij');
      if (toggle && !toggle.querySelector('.facets-toggle__wrapper')) {
        toggle.classList.add('pf-leeg');
      }
    } else if (thuis && wrapper.parentElement !== thuis) {
      thuis.appendChild(wrapper);
      if (nav) nav.classList.remove('pf-kruimelrij');
      if (toggle) toggle.classList.remove('pf-leeg');
    }
  }

  function gepland() {
    if (bezig) return;
    bezig = true;
    requestAnimationFrame(function () {
      bezig = false;
      plaats();
    });
  }

  function start() {
    plaats();

    if (mq.addEventListener) {
      mq.addEventListener('change', plaats);
    } else if (mq.addListener) {
      mq.addListener(plaats);
    }

    /* Het thema hertekent de resultatenlijst bij elke filterwijziging. Het verplaatsen zelf
       veroorzaakt ook een mutatie, maar de tweede ronde vindt het vak al op zijn plek en doet
       niets meer — geen lus dus. */
    var lijst = document.querySelector('results-list') || document.querySelector('.product-grid-container');
    if (lijst && window.MutationObserver) {
      new MutationObserver(gepland).observe(lijst, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();